<script setup lang="ts">
  defineOptions({ name: 'CPCheckbox', inheritAttrs: false })

  // External library imports
  import type { PropType } from 'vue'

  import { HLCheckbox } from '@platform-ui/highrise'

  // Type imports

  // Props definitions
  const props = defineProps({
    id: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    indeterminate: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String as PropType<'sm' | 'md' | 'lg'>,
      required: false,
      default: 'md',
    },
    label: {
      type: String,
      required: false,
      default: undefined,
    },
  })

  // Emits definitions
  const emit = defineEmits<{
    'update:checked': [checked: boolean, event: Event]
  }>()

  // Event handlers
  const handleUpdateChecked = (checked: boolean, event: Event): void => {
    emit('update:checked', checked, event)
  }
</script>

<template>
  <HLCheckbox
    v-bind="$attrs"
    :id="props.id"
    :checked="props.checked"
    :disabled="props.disabled"
    :indeterminate="props.indeterminate"
    :size="props.size"
    :label="props.label"
    @update:checked="handleUpdateChecked"
  >
    <slot />
  </HLCheckbox>
</template>

<style scoped></style>
